import { CheckCircle, PhoneCall, CircleX } from "lucide-react";
import { cn } from "@/shared/utils/style.util";

const ICONS = {
  CheckCircle,
  PhoneCall,
  CircleX,
} as const;

const ICON_CONFIG = {
  CheckCircle: { color: "text-green-600" },
  PhoneCall: { color: "text-blue-600" },
  CircleX: { color: "text-red-600" },
} as const;

type StepProps = {
  isActive: boolean
  icon: keyof typeof ICONS
  title: string
  description?: string
  activeColor?: string
};

const TwoFaNoticeStep = ({
  isActive,
  icon,
  title,
  description,
  activeColor,
}: StepProps) => {
  const IconComponent = ICONS[icon];
  const defaultColor = ICON_CONFIG[icon]?.color ?? "text-green-600";
  const color = activeColor ?? defaultColor;
  const inactiveColor = "text-gray-500";

  return (
    <div className="flex items-start gap-2">
      <div className="z-10 rounded-full bg-white p-1.5 flex items-center">
        <IconComponent size={24} className={cn(isActive ? color : inactiveColor)} />
      </div>

      <div className="flex-1 flex flex-col space-y-4">
        <span className={cn(
          "font-semibold pt-1.5",
          !isActive && "text-gray-500",
        )}
        >
          {title}
        </span>

        {description && (
          <span className={cn(
            "text-xs tabular-nums",
            isActive ? color : inactiveColor,
          )}
          >
            {description}
          </span>
        )}
      </div>
    </div>
  );
};

export default TwoFaNoticeStep;
